import { company_name } from "@/i18n/variables";

const sign_in = {
	/* -------------------------------------------------------------------------- */
	/*                            AKTIVIEREN SIE DIE KONTO SEITE                           */
	/* -------------------------------------------------------------------------- */
	activate: {
		description:
			"Schließen Sie die Registrierung Ihres Kontos ab, indem Sie ein Passwort festlegen.",
		status: {
			expired: {
				description:
					"Der Aktivierungslink ist abgelaufen und kann nicht mehr verwendet werden. Bitten Sie Ihren Kontoadministrator um eine neue Einladung.",
				title: "Aktivierungslink abgelaufen!",
			},
			invalid: {
				description:
					"Ihr Antrag zur Aktivierung Ihres Kontos wurde abgelehnt. Überprüfen Sie Ihren Link oder kontaktieren Sie uns bei anhaltenden Problemen.",
				title: "Konto nicht aktiviert!",
			},
			success: {
				description: "Ihr Konto ist aktiv und Sie können sich einloggen.",
				title: "Dein endgültiger Benutzername ist <strong>{{username}}</strong> geworden!",
			},
			unknown: {
				description:
					"Es ist ein Fehler bei der Hinzufügung eines neuen Benutzers aufgetreten. Versuchen Sie es erneut oder kontaktieren Sie unsere Support-Abteilung bei anhaltenden Problemen.",
				title: "Konto nicht aktiviert!",
			},
		},
		title: "Registrierung abschließen",
	},

	/* -------------------------------------------------------------------------- */
	/*                           IP-ADRESSE ENTSperren SEITE                          */
	/* -------------------------------------------------------------------------- */
	deblock_ip: {
		status: {
			expired: {
				description:
					"Ihre Anfrage ist abgelaufen und der Link ist nicht mehr gültig. Sie können erneut um Passwortwiederherstellung bitten.",
				title: "Anfrage abgelaufen!",
			},
			invalid: {
				description:
					"Der von Ihnen eingegebene Entsperrungslink ist ungültig und wird von uns nicht erkannt.",
				title: "Entsperrungslink ungültig!",
			},
			success: {
				description:
					"Ihre IP-Adresse wurde erfolgreich entsperrt, Sie können sich jetzt wieder von Ihrer IP-Adresse aus anmelden.",
				title: "IP-Adresse erfolgreich entsperrt!",
			},
			unknown: {
				description:
					"Es ist ein Fehler aufgetreten, sodass wir Ihre IP-Adresse nicht entsperren können. Bitte kontaktieren Sie den Support.",
				title: "IP-Adresse entsperren fehlgeschlagen!",
			},
		},
		title: "IP-Adresse entsperren",
	},

	/* -------------------------------------------------------------------------- */
	/*                           PASSWORT VERGESSEN SEKTION                          */
	/* -------------------------------------------------------------------------- */
	forgot_password: {
		confirmation: {
			description:
				"Wenn Ihr Benutzername bei uns bekannt ist, erhalten Sie per E-Mail einen Link, mit dem Sie ein neues Passwort festlegen können. Haben Sie keine E-Mail erhalten? Überprüfen Sie Ihren Spamfilter.",
			title: "E-Mail gesendet",
		},
		description:
			"Geben Sie Ihren Benutzernamen ein und Sie erhalten eine E-Mail mit einem Link, um Ihr Passwort zurückzusetzen.",
		disabled_user: {
			description:
				"Wenn Ihr Benutzername bei uns bekannt ist, erhalten Sie per E-Mail einen Link, mit dem Sie ein neues Passwort festlegen können. Wenn Sie keine E-Mail erhalten haben, ist Ihr Benutzername möglicherweise nicht bei uns bekannt.",
		},
		hostfact_user: {
			description:
				"Sie versuchen, sich mit einem klanten.tuxis.nl Konto anzumelden. Vielleicht wurde ein persönliches Konto erstellt. Melden Sie sich mit diesem an. Wenn dies das erste Mal ist, dass Sie sich mit Ihren klanten.tuxis.nl Konto in diesem Portal anmelden, stellen Sie bitte Ihr Passwort unter https://klanten.tuxis.nl wieder her und kehren Sie dann hierher zurück.",
		},
		title: "Passwort vergessen?",
	},

	/* -------------------------------------------------------------------------- */
	/*                          BENUTZERNAME VERGESSEN SEKTION                          */
	/* -------------------------------------------------------------------------- */
	forgot_username: {
		confirmation: {
			description:
				"Wenn Ihre E-Mail-Adresse bei uns bekannt ist, erhalten Sie per E-Mail Ihren Benutzernamen. Haben Sie keine E-Mail erhalten? Überprüfen Sie Ihren Spamfilter.",
			title: "E-Mail gesendet",
		},
		description:
			"Geben Sie die E-Mail-Adresse ein, die Sie auf diesem Portal verwenden, und Sie erhalten eine Liste aller registrierten Benutzernamen, die mit dieser E-Mail-Adresse verknüpft sind.",
		title: "Benutzername vergessen?",
	},
	/* -------------------------------------------------------------------------- */
	/*                                ANMELDUNG SEITE                                */
	/* -------------------------------------------------------------------------- */
	index: {
		confirm_email: {
			button: "Zur Startseite",
			message:
				"Es wurde eine Bestätigungs-E-Mail an <strong>{{email_address}}</strong> gesendet, um die Adresse zu bestätigen. Diese E-Mail enthält Anweisungen zur Validierung Ihrer E-Mail-Adresse und alle erforderlichen Angaben zur Bestätigung. Es ist wichtig, dass Sie die Validierung durchführen, damit wir Ihren Antrag bearbeiten können.",
			title: "E-Mail-Adresse bestätigen",
		},
		form: {
			description:
				"Um Zugriff auf das Portal zu erhalten, müssen Sie sich mit Ihrem Benutzernamen und Passwort anmelden.",
			links: {
				forgot_password: "Passwort vergessen?",
				forgot_username: "Benutzername vergessen?",
				new_user: {
					part1: `Noch kein Kunde von ${company_name}?`,
					part2: "Hier ein Konto erstellen!",
				},
			},
			register: {
				title: "Konto erstellen",
			},
			title: "Anmelden",
		},
		modal: {
			description:
				"2FA ist auf Ihrem Konto aktiviert. Geben Sie Ihren Autorisierungscode ein, um Zugang zum Portal zu erhalten.",
			title: "Zwei-Faktor-Authentifizierung (2FA)",
		},
		section: {
			description: {
				href: "https://support.tuxis.nl/en/knowledgebase/article/using-your-klanten-tuxis-nl-account-and-transferring-it-to-portal-tuxis-cloud-portal",
				text: "Auf diesem Portal können Sie Produkte bestellen und verwalten. Erstellen Sie im Portal ein kostenloses persönliches Konto für sich selbst und Mitarbeiter und/oder externe Parteien, die etwas für Sie tun müssen. Sie können beispielsweise festlegen, dass jemand ein VPS erstellen, aber keine Rechnungen anzeigen kann. Sie können Produkte auch mit Beziehungen verknüpfen, sodass Sie immer wissen, welche Abteilung oder welcher Kunde ein bestimmtes Produkt oder eine bestimmte Dienstleistung verwendet.<br/><br/>Bestehender Kunde und neu in diesem Portal? Lesen Sie <a>hier</a>, was Sie tun müssen, um sich zum ersten Mal beim Portal anzumelden. Neukunde? Klicken Sie dann auf Registrieren.",
			},
			title: "Hochwertige Lösungen für ehrgeizige Unternehmen",
		},
		status: {
			debtor_blocked: "Schuldner gesperrt. Kontaktieren Sie unsere Support-Abteilung.",
			email_resend: "Erfolgreich! Wir haben Ihnen eine neue Bestätigungs-E-Mail gesendet.",
			expired_hostfact_user: {
				msg: {
					href: "https://support.tuxis.nl/de/tickets/create/step1",
					text: "Sie versuchen, sich mit Ihrem customers.tuxis-Konto anzumelden. Da bereits ein persönliches Konto erstellt wurde, sollten Sie sich mit diesem anmelden. Wenn Sie noch kein persönliches Konto haben, wenden Sie sich bitte an den Kollegen, der möglicherweise ein persönliches Konto hat. Sie wissen nicht, wer das ist? Dann fragen Sie über ein Ticket auf <a>support.tuxis.nl</a>.",
				},
				title: "Persönliches Konto verwenden",
			},
			hostfact_debtor_mapping_issue:
				"Derzeit ist es nicht möglich, sich mit Ihrer bestehenden Debitorennummer anzumelden. Kontaktieren Sie unsere Support-Abteilung.",
			inactive: "Sie müssen Ihre E-Mail-Adresse bestätigen, um auf Ihr Konto zugreifen zu können.",
			invalid: "Ihr Benutzername oder Ihr Passwort ist falsch.",
			invalid_format:
				'Fehlercode: Benutzername entspricht nicht dem gewünschten Format. Verwenden Sie "Benutzername@DBxxxx" mit xxxx als Debitorennummer.',
			open_invite:
				"Sie haben Ihr Konto noch nicht aktiviert. Dies können Sie tun, indem Sie auf den Link in der E-Mail klicken, die Sie von uns erhalten haben. Keine E-Mail erhalten? Kontaktieren Sie Ihren Account-Administrator.",
			user_blocked: "Benutzer gesperrt. Kontaktieren Sie Ihren Administrator.",
			user_blocked_by_ip: {
				part_1:
					"Ihre IP-Adresse wurde aufgrund zu vieler fehlgeschlagener Anmeldeversuche gesperrt.",
				part_2: "Ihren Account entsperren",
			},
		},
	},

	/* -------------------------------------------------------------------------- */
	/*                             PASSWORT ZURÜCKSETZEN SEITE                            */
	/* -------------------------------------------------------------------------- */
	password_reset: {
		description:
			"Sie können jetzt ein neues Passwort festlegen. Nach dem Festlegen wird Ihr altes Passwort ungültig.",
		error_messages: {
			no_match: "Ihre Passwörter stimmen nicht überein!",
		},
		status: {
			expired: {
				description:
					"Ihr Antrag ist abgelaufen und der Link ist nicht mehr gültig. Sie können erneut um Passwortwiederherstellung bitten.",
				title: "Anfrage abgelaufen!",
			},
			invalid: {
				description:
					"Ihr Antrag zur Änderung des Passworts wurde abgelehnt. Überprüfen Sie Ihren Link oder kontaktieren Sie uns bei anhaltenden Problemen.",
				title: "Anfrage abgelehnt!",
			},
			not_allowed: {
				description:
					"Das Passwort eines HostFact-Benutzers kann nicht über das Portal geändert werden. Dies muss über HostFact erfolgen.",
				title: "HostFact-Passwort kann nicht geändert werden!",
			},
			success: {
				description:
					"Ihr Passwort wurde erfolgreich geändert. Sie können sich jetzt mit Ihrem neuen Passwort anmelden.",
				title: "Passwort erfolgreich geändert",
			},
			unknown: {
				description:
					"Ihr Antrag zur Änderung des Passworts wurde abgelehnt. Überprüfen Sie Ihren Link oder kontaktieren Sie uns bei anhaltenden Problemen.",
				title: "Anfrage abgelehnt!",
			},
		},
		title: "Passwort zurücksetzen",
	},

	/* -------------------------------------------------------------------------- */
	/*                           IP-ADRESSE ENTSperren SEKTION                          */
	/* -------------------------------------------------------------------------- */
	request_deblock_link: {
		confirmation: {
			description:
				"Wenn Ihre E-Mail-Adresse bei uns bekannt ist, erhalten Sie per E-Mail einen Link, mit dem Sie Ihr Konto entsperren können. Haben Sie keine E-Mail erhalten? Überprüfen Sie Ihren Spamfilter.",
			title: "E-Mail gesendet",
		},
		description:
			"Ihre IP-Adresse wurde aufgrund zu vieler fehlgeschlagener Anmeldeversuche gesperrt. Sie können Ihr Konto entsperren, indem Sie Ihren Benutzernamen unten eingeben. Sie erhalten eine E-Mail mit einem Link zur Entsperrung.",
		title: "IP-Adresse entsperren",
	},
};

export default sign_in;
